<div>
    <div @divState class="return-action-container" mat-dialog-actions>
      <h1 mat-dialog-title class="h1-settings">{{data.image.FileName}}</h1>
      <mat-icon class="icon-settings-close" mat-dialog-close>close</mat-icon>
    </div>
    <div>
      <img [src]="imageSafeUrl">
    </div>
</div>